'use client';

import TrendexLogo from '@/assets/icons/trendex.svg';
import { HeaderClient } from '@/components/header/HeaderClient';
import { Link, usePathname } from '@/i18n/navigation';
import { cn } from '@/lib/utils/cn';

interface I_HeaderProps {
  firstPoolSlug?: string | null;
  type?: 'default' | 'reward';
  isNotFound?: boolean;
}

export function Header({
  type = 'default',
  firstPoolSlug,
  isNotFound = false
}: I_HeaderProps) {
  const isReward = type === 'reward';
  const pathname = usePathname();
  const isProfilePage = pathname.includes('/profile');

  return (
    <header
      className={cn(
        'w-full bg-background border-b border-border sticky top-0 z-50',
        isProfilePage && 'hidden md:block'
      )}
    >
      <div className="mx-auto px-3.5 py-3 md:px-6 md:py-2.5">
        <div className="flex items-center justify-between w-full">
          <div
            className={cn(
              'flex items-center justify-center md:w-auto ',
              isReward ? 'justify-center md:justify-start flex-1' : ''
            )}
          >
            <Link
              href="/"
              className="hover:opacity-80 transition-opacity"
              aria-label="Trendex home"
            >
              <TrendexLogo height="18" className="w-60 max-md:w-50" />
            </Link>
          </div>

          <HeaderClient
            firstPoolSlug={firstPoolSlug}
            type={type}
            isNotFound={isNotFound}
          />
        </div>
      </div>
    </header>
  );
}
